export default __webpack_public_path__ + "img/8e52ad14aa328fc9184a392886018231.png";